/*
|--------------------------------------------------------------------------
| Utilities: WEATHER
|--------------------------------------------------------------------------
*/
__gh__webApp.utilities.weather = {
	"init":function(){
		var currentDomain = __gh__coreData.siteData.baseURL;
		$("#toprail-weather").load(currentDomain+"/section/?template=ajaxWeather");
		$("#drawer-weather").load(currentDomain+"/section/?template=ajaxWeather");
	}
};
